// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__2WJFq","title":"Card_title__3TNls","content":"Card_content__3Aw6p"};